import intervenerService from '../../../services/interveners.service';
import UsersService from '../../../services/users.service';

export default {
    name: 'UpdateTwoFactorAuth',

    data() {
        return {
            show: true
        };
    },

    mounted() {},

    methods: {
        activeTwoFactorAuth() {
            this.updateTwoFactorAuth(true);
        },
        cancelTwoFactorAuth() {
            this.updateTwoFactorAuth(false);
        },
        async updateTwoFactorAuth(enable) {
            const body = {
                has_enable_two_factor_auth: enable
            };

            const intervener = UsersService.getIntervenerFromLocalStore();

            await intervenerService.updateIntervenerData({}, body, intervener.uuid);

            this.$bvToast.toast('Datos actualizados correctamente', {
                title: 'Actualizado',
                autoHideDelay: 2000,
                variant: 'success'
            });

            this.$router.push({ name: 'Position' });
        }
    }
};
